export const required = () => ({
  name: 'required',
  staticProps: {
    'aria-required': 'true'
  },
  validate: function (fieldName) {
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (value) {
      return null;
    }

    return `${fieldName} is required`;
  }
}); // Taken from here: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#basic_validation

const emailPattern = // eslint-disable-next-line max-len
/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const email = () => ({
  name: 'email',
  staticProps: {
    /* autocomplete: 'email' ???? */

    /* Other than aria props it may not make sense to set anything else here
      in cases where this is used in non `input` elements
    */
  },
  validate: function (fieldName) {
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (value && !emailPattern.test(value)) {
      return 'Must be a valid email';
    }

    return null;
  }
});
export const minLength = min => ({
  name: 'minLength',
  staticProps: {},
  validate: function (fieldName) {
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (value && value.length < min) {
      return `${fieldName} must be at least ${min} characters`;
    }

    return null;
  }
});
export const maxLength = max => ({
  name: 'maxLength',
  staticProps: {},
  validate: function (fieldName) {
    let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (value && value.length > max) {
      return `${fieldName} must be less than or equal to ${max} characters`;
    }

    return null;
  }
});
export const pattern = function (regExp) {
  let patternMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : regExp;
  let message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    name: 'pattern',
    staticProps: {},
    validate: function (fieldName) {
      let value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (value && !regExp.test(value)) {
        if (message) {
          return message;
        }

        return `${fieldName} must match pattern ${patternMsg}`;
      }

      return null;
    }
  };
};